<template>
  <div>
    <div class="row row-space-10">
      <!-- begin col-6 -->
      <div class="col-lg-12 col-md-12">
        <!-- begin card -->
        <div
          class="card border-0 text-truncate mb-3"
          :class="{ 'bg-dark text-white': inverseMode }"
        >
          <div class="card-body">
						<ts-loading-banner :loading="loading">
							<div class="mb-3 text-grey">
								<b class="mb-3">PRODUCT WARRANTY EXPIRED</b>
								<span class="ml-2"
									><i
										class="fa fa-info-circle"
										title="Product Warranty Expired"
										v-b-popover.hover="
											'Show product in hand of each sale nearly expire.'
										"
									></i
								></span>
							</div>
							<div class="ts-overflow-y-scroll" style="min-height: 100px; max-height: 200px">
								<table class="ts-w-full">
									<thead>
										<tr class="ts-border-b ts-border-gray-400">
											<th class="ts-py-1 ts-px-2">USER NAME</th>
											<th class="ts-py-1 ts-px-2">SALE NAME</th>
											<th class="ts-py-1 ts-px-2 ts-w-32">BARCODE</th>
											<th class="ts-py-1 ts-px-2 ts-w-64">PRODUCT NAME</th>
											<th class="ts-py-1 ts-px-2 ts-w-32 ts-text-right">QUANTITIES</th>
											<th class="ts-py-1 ts-px-2 ts-w-10">NUMBER DAY</th>
											<th class="ts-py-1 ts-px-2 ts-w-20">DATE</th>
										</tr>
									</thead>
									<tbody>
										<tr class="ts-border-b"
											v-for="(p, index) in resources"
											:key="index"
										>
											<td class="ts-py-1 ts-px-2">{{ p.user_name }}</td>
											<td class="ts-py-1 ts-px-2">{{ p.sale_name }}</td>
											<td class="ts-py-1 ts-px-2">{{ p.barcode }}</td>
											<td class="ts-py-1 ts-px-2">{{ p.product_name_en }}</td>
											<td class="ts-py-1 ts-px-2 ts-text-right">{{ p.quantity }} Unit</td>
											<td class="ts-py-1 ts-px-2 ts-text-red-600">{{ p.expire_in_xx_day }} Day</td>
											<td class="ts-py-1 ts-px-2 ts-text-red-600">{{ p.product_warranty_expiry_date }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ts-loading-banner>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'productWarrantyExpired',
  props: ['inverseMode'],
  data() {
    return {
			loading: false,
      resources: []
			// getProductWarrantyExpired
    }
  },
	created() {
		this.fetchData()
	},
	methods: {
		...mapActions('dashboard/widget', [
      'getProductWarrantyExpired'
    ]),
		async fetchData () {
      this.loading = true
      await this.getProductWarrantyExpired()
        .then(responses => {
          this.resources = responses
        })
        .finally(() => {
          // this.$toasted.error(error.message)
          this.loading = false
        })
    }
	},
}
</script>
